import React from "react";
import { motion } from "framer-motion";
import { Package } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { PRODUCTS } from "../lib/site";

const Products = () => {
  const { t } = useLang();
  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative py-24 md:py-36 bg-black border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="label-eyebrow text-gold">{t.products.eyebrow}</span>
            </div>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              {t.products.title}
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-white/60 leading-relaxed">{t.products.desc}</p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-sm overflow-hidden">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: i * 0.06 }}
              data-testid={`product-card-${i}`}
              className="group bg-[#0d0d0d] hover:bg-[#111111] p-7 md:p-9 transition-all relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 right-0 h-px gold-line opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="h-10 w-10 rounded-sm bg-gold/10 border border-gold/30 flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                      <Package className="h-4.5 w-4.5 text-gold" strokeWidth={1.8} />
                    </span>
                    <span className="label-eyebrow text-white/40 text-[10px]">
                      0{i + 1} · {p.tag}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl uppercase tracking-tight leading-tight">
                    {p.name}
                  </h3>
                </div>
                <div className="font-display text-3xl md:text-4xl text-gold tracking-tight">
                  {p.price}
                </div>
              </div>
              <div className="mt-6 pt-5 border-t border-white/5">
                <span className="label-eyebrow text-white/40 text-[10px]">
                  {t.products.cta}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
